import { useTheme } from "@mui/material";
import {
	BarChart3,
	Bell,
	HelpCircle,
	IdCard,
	Settings,
	Shield,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { AppRouting } from "web_myplann/Infrastructure/Utils/UrlUtils";
import type { SettingsMenuItemType } from "web_myplann/More/Components/SettingsMenuItem";
import {
	ICON_BLUE_BG,
	ICON_BLUE_COLOR,
	ICON_EMERALD_BG,
	ICON_EMERALD_COLOR,
	ICON_GREEN_BG,
	ICON_GREEN_COLOR,
	ICON_INDIGO_BG,
	ICON_INDIGO_COLOR,
} from "web_myplann/Utils/constants";

export const useSettingsMenuItems = () => {
	const theme = useTheme();
	const { t } = useResource();
	const navigate = useNavigate();

	const toolItems: SettingsMenuItemType[] = [
		{
			icon: BarChart3,
			label: t(Resources.Settings.Items.FinancialBalance),
			iconBg: ICON_EMERALD_BG,
			iconColor: ICON_EMERALD_COLOR,
			onClick: () =>
				navigate(AppRouting.MyPlann.Finances.Intro.path(), {
					state: { from: "profile" },
				}),
		},
		{
			icon: IdCard,
			label: t(Resources.Settings.Items.MyDocuments),
			iconBg: ICON_INDIGO_BG,
			iconColor: ICON_INDIGO_COLOR,
			onClick: () => navigate(AppRouting.MyPlann.Profile.Paperwork.path()),
		},
	];

	const settingsItems: SettingsMenuItemType[] = [
		{
			icon: Settings,
			label: t(Resources.Settings.Items.Settings),
			iconBg: theme.palette.grey[100],
			iconColor: theme.palette.grey[600],
		},
		{
			icon: Bell,
			label: t(Resources.Settings.Items.Notifications),
			iconBg: ICON_BLUE_BG,
			iconColor: ICON_BLUE_COLOR,
			onClick: () => navigate(AppRouting.MyPlann.Notifications.path()),
		},
		{
			icon: Shield,
			label: t(Resources.Settings.Items.Security),
			iconBg: ICON_GREEN_BG,
			iconColor: ICON_GREEN_COLOR,
			onClick: () => navigate(AppRouting.MyPlann.Profile.Security.path()),
		},
	];

	const supportItems: SettingsMenuItemType[] = [
		{
			icon: HelpCircle,
			label: t(Resources.Settings.Items.HelpAndSupport),
			iconBg: ICON_BLUE_BG,
			iconColor: ICON_BLUE_COLOR,
		},
	];

	return { toolItems, settingsItems, supportItems };
};
